import { render } from "./WhoWeServeSection.vue?vue&type=template&id=ba7356f0"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__